import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteTitle: {
        id: 'gateway.views.new-quote-account-search.New Quote: Search for Existing Account',
        defaultMessage: 'New Quote: Search for Existing Account',
    },
    accountType: {
        id: 'gateway.views.new-quote-account-search.AccountType',
        defaultMessage: 'Account Type',
    },
    commercial: {
        id: 'gateway.views.new-quote-account-search.ContactType.Company',
        defaultMessage: 'Commercial',
    },
    personal: {
        id: 'gateway.views.new-quote-account-search.ContactType.Person',
        defaultMessage: 'Personal',
    },
    person: {
        id: 'gateway.views.new-quote.Person',
        defaultMessage: 'Person',
    },
    company: {
        id: 'gateway.views.new-quote.Company',
        defaultMessage: 'Company',
    },
    city: {
        id: 'gateway.views.new-quote.City',
        defaultMessage: 'City',
    },
    zipCode: {
        id: 'gateway.views.new-quote.ZipCode',
        defaultMessage: 'ZIP Code',
    },
    postalCode: {
        id: 'gateway.views.new-quote.PostalCode',
        defaultMessage: 'Postal Code',
    },
    state: {
        id: 'gateway.views.new-quote.Province Label',
        defaultMessage: 'Province',
    },
    cancel: {
        id: 'gateway.views.new-quote.Cancel',
        defaultMessage: 'Cancel',
    },
    search: {
        id: 'gateway.views.new-quote-account-search.Search',
        defaultMessage: 'Search',
    },
    firstName: {
        id: 'gateway.views.new-quote.FirstName',
        defaultMessage: 'First Name',
    },
    middleName: {
        id: 'gateway.views.new-quote.MiddleName',
        defaultMessage: 'Middle Name',
    },
    lastName: {
        id: 'gateway.views.new-quote.LastName',
        defaultMessage: 'Last Name',
    },
    possibleAccountMatches: {
        id: 'gateway.views.new-quote-account-search.Possible Account Matches',
        defaultMessage: 'Possible Account Matches',
    },
    searchAgain: {
        id: 'gateway.views.new-quote-account-search.Search Again',
        defaultMessage: 'Search Again',
    },
    continueNewCustomer: {
        id: 'gateway.views.new-quote-account-search.Continue as a New Customer',
        defaultMessage: 'Continue as a New Customer',
    },
    possibleBaseQuote: {
        id: 'gateway.views.new-quote-account-search.The following existing accounts may represent this customer. Please review, and if there is a match, use the existing account as a base for this quote',
        defaultMessage: 'The following existing accounts may represent this customer. Please review, and if there is a match, use the existing account as a base for this quote.'
    },
    detailsAccount: {
        id: 'gateway.views.new-quote-account-search.You do not have access to the details of this account',
        defaultMessage: 'You do not have access to the details of this account.'
    },
    headerUseAccount: {
        id: 'gateway.views.new-quote-account-search.Use this Account',
        defaultMessage: 'Use this Account'
    },
    headerNumber: {
        id: 'gateway.views.new-quote-account-search.Number',
        defaultMessage: 'Number'
    },
    headerName: {
        id: 'gateway.views.new-quote-account-search.Name',
        defaultMessage: 'Name'
    },
    headerAddress: {
        id: 'gateway.views.new-quote-account-search.Address',
        defaultMessage: 'Address'
    },
    startNewQuote: {
        id: 'gateway.views.new-quote-account-search.Start New Quote',
        defaultMessage: 'Start New Quote'
    },
    cancelQuote: {
        id: 'gateway.controllers.NewQuoteCtrl.Cancel Quote',
        defaultMessage: "Cancel Quote?"
    },
    cancelMessage: {
        id: 'gateway.controllers.NewQuoteCtrl.Are you sure you want to cancel the new quote?',
        defaultMessage: 'Are you sure you want to cancel the new quote?'
    },
    quoteTitleNewQuote: {
        id: 'gateway.views.new-quote.New Quote: New Account Details',
        defaultMessage: 'New Quote: New Account Details',
    },
    email: {
        id: 'gateway.views.new-quote.Email Address',
        defaultMessage: 'Email Address',
    },
    next: {
        id: 'gateway.views.new-quote.Next',
        defaultMessage: 'Next',
    },
    effectiveDate: {
        id: 'gateway.views.new-quote.Effective Date',
        defaultMessage: 'Effective Date',
    },
    productCode: {
        id: 'gateway.views.new-quote.Line of Business',
        defaultMessage: 'Line of Business',
    },
    existingAccountPolicyDetails: {
        id: 'gateway.views.new-quote.New Quote: Policy Details for Existing Account',
        defaultMessage: 'New Quote: Policy Details for Existing Account',
    },
    account: {
        id: 'gateway.views.new-quote.Account',
        defaultMessage: 'Account',
    },
    accountTypeErrorMessage: {
        id: 'gateway.views.new-quote.error.findAccount.account.type',
        defaultMessage: 'Account type must be a Company or a Person'
    },
    contactTypeCommercial: {
        id: 'gateway.views.new-quote-account-search.ContactType.Company',
        defaultMessage: 'Commercial'
    },
    contactTypePersonal: {
        id: 'gateway.views.new-quote-account-search.ContactType.Person',
        defaultMessage: 'Personal'
    },
    newAccountCreateErrorMessage: {
        id: 'gateway.views.new-quote.error.create.account',
        defaultMessage: 'Could not create the Account'
    },
    quoteQrganisation: {
        id: 'gateway.views.new-quote.Organization',
        defaultMessage: 'Organization'
    },
    noResults: {
        id: 'gateway.views.new-quote.No results found!',
        defaultMessage: 'No account has been found based on your criteria.'
    },
    noLengthMatch: {
        id: 'gateway.views.new-quote.PersonNo results found! At least five letters are required',
        defaultMessage: 'No results found! At least five letters are required for person first and last name without exact matches'
    },
    noResultsFound: {
        id: 'gateway.views.new-quote.No results found! At least five letters are required',
        defaultMessage: 'No results found. At least five letters are required for the first and last name of a person without exact matches.'
    },
    Eis: {
        id: 'gateway.views.new-quote.Environmental Impairment and Storage Tanks',
        defaultMessage: 'Environmental Impairment and Storage Tanks'
    },
    FooRef: {
        id: 'gateway.views.new-quote.Food Truck / Refreshment Cart',
        defaultMessage: 'Food Truck / Refreshment Cart'
    },
    VacTra: {
        id: 'gateway.views.new-quote.Vacation Trailer',
        defaultMessage: 'Vacation Trailer'
    },
    MotCyc: {
        id: 'gateway.views.new-quote.Motorcycle',
        defaultMessage: 'Motorcycle'
    },
    OffRoaVeh: {
        id: 'gateway.views.new-quote.Off-Road Vehicles',
        defaultMessage: 'Off-Road Vehicles'
    },
    DroUnmAir: {
        id: 'gateway.views.new-quote.Drone /Unmanned Aircraft',
        defaultMessage: 'Drone /Unmanned Aircraft'
    },
    MarPle: {
        id: 'gateway.views.new-quote.Marine Pleasurecraft',
        defaultMessage: 'Marine Pleasurecraft'
    },
    Hol: {
        id: 'gateway.views.new-quote.Hole In One',
        defaultMessage: 'Hole In One'
    },
    Sel: {
        id: 'gateway.views.new-quote.Special Events Liability',
        defaultMessage: 'Special Events Liability'
    },
    HeaWelFitFac: {
        id: 'gateway.views.new-quote.Health and Wellness - Fitness Facilities, Tanning Salons, Personal Trainers',
        defaultMessage: 'Health and Wellness - Fitness Facilities, Tanning Salons, Personal Trainers'
    },
    BeaSpaWel: {
        id: 'gateway.views.new-quote.Beauticians, Spa and Wellness',
        defaultMessage: 'Beauticians, Spa and Wellness'
    },
    EquBre: {
        id: 'gateway.views.new-quote.Equipment Breakdown',
        defaultMessage: 'Equipment Breakdown'
    },
    BuiRisAllTyp: {
        id: 'gateway.views.new-quote.Builders Risks - All types of Construction',
        defaultMessage: 'Builders Risks - All types of Construction'
    },
    Cond: {
        id: 'gateway.views.new-quote.Condominiums',
        defaultMessage: 'Condominiums'
    },
    RisAssDwe: {
        id: 'gateway.views.new-quote.Risk Assist - Dwellings',
        defaultMessage: 'Risk Assist - Dwellings'
    },
    TinHom: {
        id: 'gateway.views.new-quote.Tiny Homes',
        defaultMessage: 'Tiny Homes'
    },
    MobHom: {
        id: 'gateway.views.new-quote.Mobile Home',
        defaultMessage: 'Mobile Home'
    },
    PerUmbLia: {
        id: 'gateway.views.new-quote.Personal Umbrella Liablity',
        defaultMessage: 'Personal Umbrella Liablity'
    },
    PerProInSto: {
        id: 'gateway.views.new-quote.Personal Property in Storage',
        defaultMessage: 'Personal Property in Storage'
    },
    CybLiaCom: {
        id: 'gateway.views.new-quote.Cyber Liability - Commercial',
        defaultMessage: 'Cyber Liability - Commercial'
    },
    CybLiaGroEmpBen: {
        id: 'gateway.views.new-quote.Cyber Liability - Group Employee Benefit',
        defaultMessage: 'Cyber Liability - Group Employee Benefit'
    },
    CybLiaPer: {
        id: 'gateway.views.new-quote.CybLiaPer',
        defaultMessage: 'Cyber Liability - Personal'
    },
    insClass: {
        id: 'gateway.views.new-quote.Insurance Class',
        defaultMessage: 'Insurance Class'
    },
    prdt: {
        id: 'gateway.views.new-quote.Product',
        defaultMessage: 'Product'
    }
});
